// extracted by mini-css-extract-plugin
export default {"reimbursementDetailsWrapper":"styles_reimbursementDetailsWrapper__UVGBM","actionBox":"styles_actionBox__u0U8L"};